export const isAdmin = () => localStorage.getItem('userRol') === 'admin';

export const isAdministrativo = () => localStorage.getItem('userRol') === 'administrativo';

export const isTecnico = () => localStorage.getItem('userRol') === 'tecnico';

export const canEdit = () => isAdmin() || isAdministrativo();

export const getUserRol = () => localStorage.getItem('userRol') || 'administrativo';

export const clearSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('userRol');
  localStorage.removeItem('userName');
};
